var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-logo inline-block"},[_c('router-link',{attrs:{"to":{ name: 'app.home' }}},[_c('inline-svg',{staticClass:"dapp-logo__image",class:_vm.theme,attrs:{"src":_vm.getImageUrl('UPDATE-Beta.svg'),"width":_vm.width}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }